import {Box, Grid, Typography} from '@mui/material';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExportIcon} from '../../../assests/svg/export-icon.svg';
import {t} from 'i18next';
import {ReactComponent as PlusIcon} from '../../../assests/svg/plus-icon.svg';

type projectListHeaderProp = {
  hasCreateProjectPermission: boolean;
  projectListExportCSVHandler: () => void;
  createNewProjectHandler: () => void;
};

const AurProjectListTableHeader = ({
  hasCreateProjectPermission = false,
  projectListExportCSVHandler,
  createNewProjectHandler,
}: projectListHeaderProp) => {
  return (
    <div>
      <Grid container>
        <Grid item xs={6}>
          <Box className="project-title-container">
            <Typography
              tabIndex={0}
              className="typo-text headline1_size project-name"
            >
              {t('clientDetailsPage.projectTable.projects')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box gap={3} className="project-export-csv-btn-container">
            <AurButton
              startIcon={<ExportIcon aria-hidden="true" />}
              type="exit"
              size="Medium"
              label={`${t('clientDetailsPage.projectTable.exportAsXLSX')}`}
              onClick={projectListExportCSVHandler}
              dataTestId="aur-project-list-export-csv-button"
            />
            {hasCreateProjectPermission ? (
              <AurButton
                type="continue"
                size="Medium"
                startIcon={<PlusIcon aria-hidden />}
                label={`${t('clientDetailsPage.projectTable.createNewProject')}`}
                onClick={createNewProjectHandler}
                dataTestId="aur-create-new-project-button"
                ariaLabel={`${t('clientDetailsPage.projectTable.createNewProject')}`}
              />
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AurProjectListTableHeader;
